import { createContext, useContext, ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PublicChampionshipContextValue {
  championship: any | null;
  championshipId: string | null;
  isLoading: boolean;
  slug: string;
}

const PublicChampionshipContext = createContext<PublicChampionshipContextValue>({
  championship: null,
  championshipId: null,
  isLoading: true,
  slug: "",
});

export function usePublicChampionship() {
  return useContext(PublicChampionshipContext);
}

export function PublicChampionshipProvider({ slug, children }: { slug: string; children: ReactNode }) {
  const { data: championship, isLoading } = useQuery({
    queryKey: ["public-championship", slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("championships")
        .select("*")
        .eq("public_slug", slug)
        .single();
      if (error) throw error;
      return data;
    },
    enabled: !!slug,
  });

  return (
    <PublicChampionshipContext.Provider
      value={{
        championship: championship || null,
        championshipId: championship?.id || null,
        isLoading,
        slug,
      }}
    >
      {children}
    </PublicChampionshipContext.Provider>
  );
}
